import styled from 'styled-components'
import React from 'react'
import { Card, Icon, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const StyledCard = styled(Card)`
 width: 300px;
  &&& {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }
  }
`

const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
`

const CardTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  color: #2c3e50;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #999;

  .icon {
    font-size: 64px;
    margin-bottom: 20px;
    opacity: 0.3;
  }

  h3 {
    color: #666;
    font-weight: 400;
  }
`

type CardDataType = {
  label?: string
  name?: string
  id: string | number
  status: number
}

interface Props {
  rows: CardDataType[]
}

const TypeCard: React.FC<Props> = ({ rows }) => {
  const { t } = useTranslation()

  if (!rows || rows.length === 0) {
    return (
      <EmptyState>
        <Icon name='file outline' />
        <h3>{t('No results available')}</h3>
      </EmptyState>
    )
  }

  return (
    <Card.Group stackable>
      {rows.map((item) => (
        <StyledCard key={item.id}>
          <Card.Content>
            <CardHeader>
              <CardTitle>{item.label || item.name}</CardTitle>
              {item.status === 1 && (
                <Label color='green' size='small' style={{ whiteSpace: 'nowrap' }}>
                  <Icon name='check circle' />
                  {t('Active')}
                </Label>
              )}
              {item.status === 0 && (
                <Label color='grey' size='small' style={{ whiteSpace: 'nowrap' }}>
                  <Icon name='circle outline' />
                  {t('Inactive')}
                </Label>
              )}
            </CardHeader>
          </Card.Content>
        </StyledCard>
      ))}
    </Card.Group>
  )
}
export default TypeCard